export const truncateDecimal = (value, decimals = 2) => {
  const num = parseFloat(value);
  if (isNaN(num)) return "0.00";

  const factor = Math.pow(10, decimals);
  return (Math.floor(num * factor) / factor).toFixed(decimals);
};